<template>
  <StoreLocatorExpandable :title="title" :expandable="expandable">
    <template #actions>
      <ui-button
        :icon="actionIcon"
        color="primary"
        :outlined="readonly"
        @click="$emit('manage')"
      >
        {{ actionName }}
      </ui-button>
    </template>
    <template #default>
      <StoreLocatorCompanyCard
        v-if="facilityData"
        :name="facilityData.name"
        :address="facilityData.formatted_address"
        :storeCode="facilityData.store_code"
      />
      <slot :items="faqItems" />
      <StoreLocatorFaqEmptyState v-if="showEmptyState && !faqItems.length">
        <ui-button color="primary" @click="$emit('manage')">
          {{ $t("message.common.add") }}
        </ui-button>
      </StoreLocatorFaqEmptyState>
    </template>
  </StoreLocatorExpandable>
</template>

<script>
import StoreLocatorExpandable from "@/components/BusinessAddresses/StoreLocatorExpandable.vue";
import StoreLocatorFaqEmptyState from "@/components/StoreLocatorFaq/StoreLocatorFaqEmptyState.vue";
import StoreLocatorCompanyCard from "@/components/BusinessAddresses/StoreLocatorCompanyCard.vue";

export default {
  name: "StoreLocatorFaqSection",
  components: {
    StoreLocatorExpandable,
    StoreLocatorFaqEmptyState,
    StoreLocatorCompanyCard
  },
  props: {
    title: {
      type: String,
      required: true
    },
    expandable: {
      type: Boolean,
      default: true
    },
    facilityData: {
      type: Object,
      validator: value => {
        return value.name && value.formatted_address && value.store_code;
      }
    },
    faqItems: {
      type: Array,
      default: () => []
    },
    showEmptyState: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    actionName() {
      return this.readonly
        ? this.$t("message.common.edit")
        : this.$t("message.common.add");
    },
    actionIcon() {
      return this.readonly ? "icon-edit" : "icon-plus";
    }
  }
};
</script>
